import { Injectable } from '@nestjs/common';
import { getManager, Repository } from 'typeorm';
import { CodeListMain } from './code-list-main.entity';
import { CodeListMainAdapter } from './dto/code-list-main.adapter';
import { CodeListMainDTO } from './dto/code-list-main.dto';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { CommonResponse, GetValueAdditionDataBySkuCodesRequest } from '@gtpl/shared-models/masters';
import { ErrorResponse, UnitRequest } from '@gtpl/shared-models/common-models';
import { CodeListMainRepository } from './repositories/code-list-main.repository';
import { AllCodeListMainResponseModel } from '@gtpl/shared-models/planning';
import appSettings from 'apps/services/config';
import { CodeListMainIdRequest } from './dto/code-list-main-id.request';
import { CodeListValidationReq } from './dto/code-list-validation-request';
import { CodeListMainItemsRepository } from './repositories/code-list-main-items.repository';
import { CodeListMainItems } from './code-list-main-items.entity';
import { SkuService } from '@gtpl/shared-services/masters'
import { CodeListMainId } from './dto/code-list-main-req';
import { CodeLisSOItemReq } from './dto/code-list-so-item-req';
import { SubJobCodeListRequest } from './dto/sub-job-code-list-req';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { SubJobRevisionCodesRequest } from './dto/sub-job-revision-codes-req';
import { CodeListlogRepository } from './repositories/code-list-log.repository';
import { CodeListLogAdapter } from './dto/code-list-log.adapter';
import { SubJobReviseReq } from './dto/sub-job-revise-req';
const util = require('util');


@Injectable()
export class CodeListMainService {

    constructor(
        private codeListMainRepository: CodeListMainRepository,
        private codeListItemRepo: CodeListMainItemsRepository,
        private codeListMainAdapter: CodeListMainAdapter,
        private skuCodesService: SkuService,
        private codeListLogRepo: CodeListlogRepository,
        private soService: SaleOrderService,
        private codeListLogAdapter: CodeListLogAdapter

    ) { }

    async getCodeListMainDetailsWithoutRelations(saleOrderId: number): Promise<CodeListMain> {
        // tslint:disable-next-line: typedef
        const CodeListMainResponse = await this.codeListMainRepository.findOne({
            where: { saleOrderId: saleOrderId },
        });
        if (CodeListMainResponse) {
            return CodeListMainResponse;
        } else {
            return null;
        }
    }


    async createCodeListInfo(dto: CodeListMainDTO, isUpdate: boolean): Promise<CommonResponse> {
        const transactionManager = new GenericTransactionManager()
        try {
            await transactionManager.startTransaction()
            if (!isUpdate) {
                const codeListEntity = await this.getCodeListMainDetailsWithoutRelations(dto.saleOrderId);
                if (codeListEntity) {
                    return new CommonResponse(false, 1111, 'Code List already exists');
                }
            }
            const convertedDtoRmE = await this.codeListMainAdapter.convertDtoToEntity(dto);
            const savedInfoRmE = await transactionManager.getCustomRepository(CodeListMainRepository).save(convertedDtoRmE);
            const codeListLogAdapter = await this.codeListLogAdapter.convertDtoToEntity(savedInfoRmE)
            for (const element of codeListLogAdapter) {
                const updateLog = await transactionManager.getCustomRepository(CodeListlogRepository).save(element)
            }
            // const updateToSaleORderTrack = await this.soService.updateCodeListStatusInSoTrack(dto.saleOrderId)
            if (savedInfoRmE) {
                await transactionManager.completeTransaction()
                return new CommonResponse(true, 1111, 'Code List along with Items Info are created successfully');
            } else {
                await transactionManager.releaseTransaction()
                throw new ErrorResponse(9999, 'Creation of Code List failed');
            }
        }
        catch (error) {
            await transactionManager.releaseTransaction()
            console.log(error)
            return error;
        }
    }

    async getAllCodeLists(req : UnitRequest): Promise<AllCodeListMainResponseModel> {
        const manager = getManager()
        const query = `select c.code_list_main_id as codeListMainId,c.sale_order_id as saleOrderId,sinv.po_number as poNumber,SUM(ci.cartons) as totalCartons,c.issued_by as issuedBy,c.is_active as isActive,cun.country_name as countryName,ec.end_customer_name as endCustomerName,mb.brand_name as brandName,sinv.job_type as jobType from ${appSettings.planning_db}.code_list_main c
        left join ${appSettings.planning_db}.code_list_main_items ci on ci.code_list_main_id = c.code_list_main_id
        left join ${appSettings.sales_db}.so_invoice_details sinv on sinv.sale_order_id = c.sale_order_id
        left join ` + appSettings.sales_db + `.sale_order_items soi on soi.sale_order_item_id = ci.sale_order_item_id 
        left join ${appSettings.masters_db}.countries cun on cun.country_id = sinv.country_id
        left join ${appSettings.masters_db}.end_customers ec on ec.end_customer_id = sinv.end_customer_id
        left join ${appSettings.masters_db}.master_brands mb on mb.master_brand_id  = soi.master_brand_id
         where ci.unit_id = ${req.unitId} group by ci.code_list_main_id`

        const data = await manager.query(query)
        for(const item of data){
            const poQuery = `select count(po_number) as count from ${appSettings.sales_db}.so_invoice_details where po_number = '${item.poNumber}' `
            const subJobPo = await manager.query(poQuery)
            if(subJobPo && subJobPo.length ){
                item.count = subJobPo[0].count
            }


        }
        if (data && data.length) {
            return new CommonResponse(true, 1111, "Data retreived sucessfully", data)
        } else {
            return new CommonResponse(false, 1111, "No data found",)
        }
    }


    async getCodeListsForId(qReq: CodeListMainIdRequest): Promise<CommonResponse> {
        try {
            const manager = getManager()
            const query = `SELECT s.code as code ,so.traceability_code as tracebilityCode,s.code_list_main_id as codeListMainId,s.production_date as productionDate,s.best_before_date as bestBeforeDate,s.cartons as cartons,s.sale_order_item_id as soItemId,s.tracebility_code_id as tracebilityCodeId,s.code_list_main_items_id as codeListMainItemId,soi.varient_id as varientId FROM ` + appSettings.planning_db + `.code_list_main_items s 
            LEFT JOIN ` + appSettings.planning_db + `.code_list so ON so.code_list_id=s.tracebility_code_id
            LEFT JOIN ` + appSettings.planning_db + `.code_list_main cm ON cm.code_list_main_id = s.code_list_main_id 
            left join ` + appSettings.sales_db + `.sale_order_items soi on soi.sale_order_item_id = s.sale_order_item_id 
             WHERE cm.sale_order_id = ${qReq.saleOrderId}`

            const qEntities: CodeListMainDTO[] = await manager.query(query)
            if (qEntities) {
                const response = new AllCodeListMainResponseModel(true, 1, 'Code List retrieved successfully', qEntities);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        } catch (err) {
            console.log(err)
            return err;
        }
    }

    async geTracebilityCodeForSoId(qReq: CodeListMainIdRequest): Promise<CommonResponse> {
        try {
            const manager = getManager();
            const qDtos: CodeListMainDTO[] = [];
            const codeListMainId: CodeListMainDTO = await this.codeListMainRepository.findOne({ where: { saleOrderId: qReq.saleOrderId } })
            if (codeListMainId != undefined) {
                const query = `SELECT CONCAT(t.traceability_code , "-", ci.code) as tracebilityCode,ci.tracebility_code_id as tracebilityCodeId,sale_order_item_id as saleOrderItemId,ci.cartons FROM ` + appSettings.planning_db + `.code_list_main c
                LEFT JOIN ` + appSettings.planning_db + `.code_list_main_items ci ON ci.code_list_main_id = c.code_list_main_id
                LEFT JOIN ` + appSettings.planning_db + `.code_list t ON t.code_list_id = ci.tracebility_code_id
                WHERE c.code_list_main_id=` + codeListMainId.codeListMainId;
                const data = await manager.query(query)

                if (data) {
                    const response = new CommonResponse(true, 1, 'Data retrieved successfully', data);
                    return response;
                } else {
                    const response = new CommonResponse(false, 1, 'Tracability codes data found.',);
                    return response;
                }
            }
            else {
                const response = new CommonResponse(false, 1, 'Tracability codes data found.',);
                return response;
            }
        } catch (err) {
            return err;
        }
    }

    async validateCodeListCartons(req: CodeListValidationReq): Promise<CommonResponse> {
        try {

            const codeListExists = await this.getCodeListMainById(req.codeListMainId)
            const updateData = await this.codeListMainRepository.update({ codeListMainId: req.codeListMainId }, { isActive: true, issuedBy: req.issuedBy, verifiedBy: req.verifiedBy, totalCartons: req.totalCartons })
            if (updateData.affected) {
                const response: CommonResponse = new CommonResponse(true, 10114, 'Validated ');
                return response;
            } else {
                throw new ErrorResponse(10112, 'Error while validating');
            }
        } catch (err) {
            return err
        }
    }

    async getCodeListMainById(codeListMainId: number): Promise<CodeListMain> {
        //  console.log(employeeId);
        const Response = await this.codeListMainRepository.findOne({
            where: { codeListMainId: codeListMainId },
        });
        // console.log(employeeResponse);
        if (Response) {
            return Response;
        } else {
            return null;
        }
    }

    async getCodeListData() {
        const manager = getManager()
        const query = `select c.code_list_main_id as codeListMainId,c.sale_order_id as saleOrderId,sinv.po_number as poNumber,c.total_cartons as totalCartons,c.issued_by as issuedBy from ${appSettings.planning_db}.code_list_main 
        left join ${appSettings.sales_db}.so_invoice_details sinv on sinv.sale_order_id = c.sale_order_id `
        
        const data = await manager.query(query)
        if (data && data.length) {
            return new CommonResponse(true, 1111, "Data retreived sucessfully", data)
        } else {
            return new CommonResponse(false, 1111, "No data found",)
        }
    }


    async getCodeListPrintData(qReq: CodeListMainIdRequest): Promise<CommonResponse> {
        const manager = getManager()
        const getSubjobSoId = `select sale_order_id from ${appSettings.sales_db}.so_invoice_details si  where si.po_number = '${qReq.poNumber}'`
        const soIdData = await manager.query(getSubjobSoId)
        console.log(soIdData)
        const soIds = soIdData.map((i) => { return i.sale_order_id })
        const getSoItemForSoId = `select c.sale_order_item_id as soItemId,soi.varient_id as varientId,pm.packing_method_name as packStyle,uc.approval_no as approvalNo,sp.rating,cm.created_at as createdDate,(concat(soi.min_grade_id,'/',soi.max_grade_id)) as grade from ${appSettings.planning_db}.code_list_main_items c
            LEFT JOIN ` + appSettings.planning_db + `.code_list_main cm ON cm.code_list_main_id = c.code_list_main_id 
            left join ${appSettings.sales_db}.so_invoice_details sinv on sinv.sale_order_id = cm.sale_order_id
            left join ` + appSettings.sales_db + `.sale_order_items soi on soi.sale_order_item_id = c.sale_order_item_id 
            left join ${appSettings.masters_db}.packing_methods pm on  pm.packing_method_id = soi.pack_style_id
            left join ${appSettings.masters_db}.unitcodes uc on uc.unit_code_id = sinv.factoryId
            left join ${appSettings.sales_db}.so_po_details sp on sp.sale_order_id = cm.sale_order_id  
           WHERE cm.sale_order_id IN (${soIds.join()}) group by soi.food_type_id,soi.value_addition_one_id,soi.value_addition_two_id,soi.value_addition_three_id,soi.value_addition_four_id,soi.pack_style_id`
        const soItemIds = await manager.query(getSoItemForSoId)
        console.log(soItemIds)
        const finData = []
        for (const element of soItemIds) {
            console.log(element)
            const query = `SELECT s.code as code ,so.traceability_code as tracebilityCode,s.code_list_main_id as codeListMainId,s.production_date as productionDate,s.best_before_date as bestBeforeDate,SUM(s.cartons) as cartons,s.sale_order_item_id as soItemId,s.tracebility_code_id as tracebilityCodeId,s.code_list_main_items_id as codeListMainItemId,soi.varient_id as varientId,soi.min_grade_id,soi.max_grade_id,concat(soi.min_grade_id,'/',soi.max_grade_id) as grade FROM ` + appSettings.planning_db + `.code_list_main_items s 
            LEFT JOIN ` + appSettings.planning_db + `.code_list so ON so.code_list_id=s.tracebility_code_id
            LEFT JOIN ` + appSettings.planning_db + `.code_list_main cm ON cm.code_list_main_id = s.code_list_main_id 
            left join ` + appSettings.sales_db + `.sale_order_items soi on soi.sale_order_item_id = s.sale_order_item_id 
            WHERE cm.sale_order_id IN (${soIds.join()}) group by tracebility_code_id `
            const data = await manager.query(query);
            const req = new GetValueAdditionDataBySkuCodesRequest(element.varientId)
            const skuData = await this.skuCodesService.getSkuCodeNamesForSkucodeId(req)
            const obj = {rating:element.rating,approvalNo:element.approvalNo, soItem: element.soItemId, packStyle: element.packStyle, codeListDetails: data, skuDetails: skuData.data,createdDate : element.createdDate,grade:element.grade }
            finData.push(obj)
        }

        if (finData && finData.length) {
            return new CommonResponse(true, 1111, "Data retreived sucessfully", finData)
        } else {
            return new CommonResponse(false, 1111, "No data found",)
        }
    }

    async getCodeListPrimaryPrintData(qReq: CodeListMainIdRequest): Promise<CommonResponse> {
        const manager = getManager()
    
           const getSoItemForSoId = `select c.sale_order_item_id as soItemId,soi.varient_id as varientId,pm.packing_method_name as packStyle,uc.approval_no as approvalNo,sp.rating,cm.created_at as createdDate,group_concat(concat(soi.min_grade_id,'/',soi.max_grade_id)) as grade from ${appSettings.planning_db}.code_list_main_items c
           LEFT JOIN ` + appSettings.planning_db + `.code_list_main cm ON cm.code_list_main_id = c.code_list_main_id 
           left join ` + appSettings.sales_db + `.sale_order_items soi on soi.sale_order_item_id = c.sale_order_item_id
           left join ${appSettings.sales_db}.so_invoice_details sinv on sinv.sale_order_id = cm.sale_order_id
           left join ${appSettings.masters_db}.packing_methods pm on  pm.packing_method_id = soi.pack_style_id
           left join ${appSettings.masters_db}.unitcodes uc on uc.unit_code_id = sinv.factoryId
           left join ${appSettings.sales_db}.so_po_details sp on sp.sale_order_id = cm.sale_order_id
           WHERE cm.sale_order_id = ${qReq.saleOrderId} group by c.sale_order_item_id `

        const soItemIds = await manager.query(getSoItemForSoId)
        console.log(soItemIds)
        const finData = []
        for (const element of soItemIds) {
            console.log(element)
            const query = `SELECT s.code as code ,so.traceability_code as tracebilityCode,s.code_list_main_id as codeListMainId,s.production_date as productionDate,s.best_before_date as bestBeforeDate,s.cartons as cartons,s.sale_order_item_id as soItemId,s.tracebility_code_id as tracebilityCodeId,s.code_list_main_items_id as codeListMainItemId,soi.varient_id as varientId FROM ` + appSettings.planning_db + `.code_list_main_items s 
            LEFT JOIN ` + appSettings.planning_db + `.code_list so ON so.code_list_id=s.tracebility_code_id
            LEFT JOIN ` + appSettings.planning_db + `.code_list_main cm ON cm.code_list_main_id = s.code_list_main_id 
            left join ` + appSettings.sales_db + `.sale_order_items soi on soi.sale_order_item_id = s.sale_order_item_id 
            WHERE cm.sale_order_id = ${qReq.saleOrderId} and s.sale_order_item_id = ${element.soItemId}`
            const data = await manager.query(query);
            const req = new GetValueAdditionDataBySkuCodesRequest(element.varientId)
            const skuData = await this.skuCodesService.getSkuCodeNamesForSkucodeId(req)
            const obj = {bapNo:element.bapNo,approvalNo:element.approvalNo, soItem: element.soItemId, packStyle: element.packStyle, codeListDetails: data, skuDetails: skuData.data,grade:element.grade }
            finData.push(obj)
        }

        if (finData && finData.length) {
            return new CommonResponse(true, 1111, "Data retreived sucessfully", finData)
        } else {
            return new CommonResponse(false, 1111, "No data found",)
        }
    }


    async getCodeListDataForUpdate(req: CodeListMainId): Promise<CommonResponse> {
        try {
            const manager = getManager()
            const query = `SELECT s.code as code ,so.traceability_code as tracebilityCode,s.code_list_main_id as codeListMainId,s.production_date as productionDate,s.best_before_date as bestBeforeDate,s.cartons as cartons,s.sale_order_item_id as soItemId,s.tracebility_code_id as tracebilityCodeId,s.code_list_main_items_id as codeListMainItemId,soi.varient_id as varientId,s.unit_id as unitId FROM ` + appSettings.planning_db + `.code_list_main_items s 
            LEFT JOIN ` + appSettings.planning_db + `.code_list so ON so.code_list_id=s.tracebility_code_id
            LEFT JOIN ` + appSettings.planning_db + `.code_list_main cm ON cm.code_list_main_id = s.code_list_main_id 
            left join ` + appSettings.sales_db + `.sale_order_items soi on soi.sale_order_item_id = s.sale_order_item_id 
             WHERE cm.code_list_main_id = ${req.codeListMainId}`
            const updateData = await manager.query(query)
            console.log(updateData)
            if (updateData && updateData.length) {
                return new CommonResponse(true, 1111, "Data retreived sucessfully", updateData)
            } else {
                return new CommonResponse(false, 1010, "No data found")
            }
        } catch {
            throw new ErrorResponse(1010, "Error found")
        }
    }

    async geTracebilityCodeForSoItem(req: CodeLisSOItemReq) {
        const manager = getManager()
        const codesdata = `SELECT DISTINCT(cl.traceability_code) FROM ` + appSettings.planning_db + `.code_list_main_items cmi LEFT JOIN ` + appSettings.planning_db + `.code_list_main cm ON cmi.code_list_main_id = cm.code_list_main_id LEFT JOIN ` + appSettings.planning_db + `.code_list cl ON cl.code_list_id = cmi.tracebility_code_id where sale_order_item_id=` + req.saleOrderItemId;
        const traceCodes = await manager.query(codesdata)
        console.log('traceCodes')
        console.log(traceCodes)
        if (traceCodes.length > 0) {
            return new CommonResponse(true, 4444, 'data found', traceCodes)
        } else {
            return new CommonResponse(false, 3333, 'data not found')
        }

    }
    async updateCodeListForSubJob(reqItems: SubJobCodeListRequest[]): Promise<CommonResponse> {
        try {
            const manager = getManager()
            const codeListMaindata = new CodeListMain();
            codeListMaindata.saleOrderId = reqItems[0].subSoId
            codeListMaindata.totalCartons = reqItems[0].SubSoJobCases
            codeListMaindata.createdUser = reqItems[0].createdUser
            const newMainCodeList = await manager.save(codeListMaindata)
            if (newMainCodeList) {

                let saveFlag = new Set<boolean>();
                for (const reqRecord of reqItems) {
                    if (reqRecord.operation == 'SUB JOB CREATE') {
                        for (const record of reqRecord.codeListInfo) {
                            const traceCodesDataQry = `select code_list_main_id as codeListMainId,code,tracebility_code_id as tracebilityCodeId,cartons,sale_order_item_id as saleOrderItemId,production_date as prodDate,best_before_date as bbfdate,created_user as createdUser from ` + appSettings.planning_db + `.code_list_main_items cmi where sale_order_item_id = ` + reqRecord.saleOrderItemId + ` and tracebility_code_id = ` + record.codeListId;
                            const traceCodesData = await manager.query(traceCodesDataQry)
                            if (traceCodesData.length > 0) {
                                const updateQty = `update ` + appSettings.planning_db + `.code_list_main_items set cartons = cartons-` + record.codeListQuantity + `,updated_user = '` + reqRecord.createdUser + `' where sale_order_item_id = ` + reqRecord.saleOrderItemId + ` and tracebility_code_id = ` + record.codeListId;
                                const updateCartons = await manager.query(updateQty)
                                if (updateCartons) {

                                    const subJobCodeList = new CodeListMainItems()
                                    subJobCodeList.codeListMainId = newMainCodeList.codeListMainId
                                    subJobCodeList.code = traceCodesData[0].code
                                    subJobCodeList.tracebilityCodeId = traceCodesData[0].tracebilityCodeId
                                    subJobCodeList.cartons = record.codeListQuantity
                                    subJobCodeList.soItemId = reqRecord.subSaleOrderItemId
                                    subJobCodeList.productionDate = traceCodesData[0].prodDate
                                    subJobCodeList.bestBeforeDate = traceCodesData[0].bbfdate
                                    subJobCodeList.createdUser = reqRecord.createdUser
                                    subJobCodeList.unitId = reqRecord.subJobUnitId
                                    const saveSubCOdeList = await manager.save(subJobCodeList)
                                    if (saveSubCOdeList) {
                                        saveFlag.add(true)
                                    } else {
                                        saveFlag.add(false)

                                    }

                                    // subJobCodeList.save()
                                } else {
                                    return new CommonResponse(false, 3333, 'Not Updated')

                                }

                            } else {
                                return new CommonResponse(false, 3333, 'No Code lIst Found')
                            }


                        }
                    } else {
                        return new CommonResponse(false, 3333, 'No operation found')

                    }
                }
                if (!(saveFlag.has(false))) {
                    return new CommonResponse(true, 3333, 'Not Updated')

                } else {
                    return new CommonResponse(false, 3333, 'some thing Not Updated')
                }
            } else {
                return new CommonResponse(false, 3333, 'something went wrong on code list saving')
            }
            return
        } catch (error) {
            return new CommonResponse(false, 3333, error)
        }

    }
    async updateCodeListFromSubJobRevision(reqItems: SubJobReviseReq): Promise<CommonResponse> {
        let manager = getManager()
        try {
            const updateflag = new Set<boolean>()
            for (const record of reqItems.traceCodesData) {
                if (record.codelistmainItemId > 0) {
                    const dataqry = `select * from code_list_main_items where tracebility_code_id = ` + record.tracebilityCodeId + ` and sale_order_item_id = ` + record.saleOrderItemId + ` and unit_id = ` + record.unitId;
                    const tracecodesdata = await manager.query(dataqry)
                    if (tracecodesdata.length > 1) {
                        updateflag.add(false)
                        break
                    }
                    if (tracecodesdata.length > 0) {
                        const updateSubSoCodesQry = `update code_list_main_items set cartons=` + record.cartons + `,updated_user = '` + reqItems.createdUser + `' where tracebility_code_id = ` + record.tracebilityCodeId + ` and sale_order_item_id = ` + record.saleOrderItemId + ` and unit_id = ` + record.unitId
                        const updateSubSoCodes = await manager.query(updateSubSoCodesQry)
                        if (updateSubSoCodes) {
                            updateflag.add(true)
                        } else {
                            updateflag.add(false)
                            break
                        }
                    } else {
                        return new CommonResponse(false, 5555, 'No trace codes found')
                    }
                } else {
                    const dataqry = `select code_list_main_id as codeListMainId,code_list_main_items_id as codeListMainItemId,production_date as productionDate,best_before_date as bestBeforeDate,code  from code_list_main_items where unit_id = ` + record.unitId + ` and sale_order_item_id = ` + record.saleOrderItemId;
                    const tracecodesdata = await manager.query(dataqry)
                    // if (tracecodesdata.length > 1) {
                    //     updateflag.add(false)
                    //     break
                    // }
                    const traceCodeObj = new CodeListMainItems()
                    traceCodeObj.codeListMainId = tracecodesdata[0].codeListMainId
                    traceCodeObj.cartons = record.cartons
                    traceCodeObj.soItemId = record.saleOrderItemId
                    traceCodeObj.tracebilityCodeId = record.tracebilityCodeId
                    traceCodeObj.unitId = record.unitId
                    traceCodeObj.cartons = record.cartons
                    traceCodeObj.createdUser = reqItems.createdUser
                    traceCodeObj.productionDate = tracecodesdata[0].productionDate
                    traceCodeObj.bestBeforeDate = tracecodesdata[0].bestBeforeDate
                    traceCodeObj.code = tracecodesdata[0].code
                    const newTaceCodeSave = await manager.getCustomRepository(CodeListMainItemsRepository).save(traceCodeObj)
                    if (!(traceCodeObj)) {
                        updateflag.add(false)
                        break
                    }
                }

            }
            if (!(updateflag.has(false))) {
                return new CommonResponse(true, 9999, 'trace codes updatec successfully')
            } else {
                await manager.release()
                return new CommonResponse(false, 9999, 'Something went wrong in updation')
            }
        } catch (err) {
            await manager.release()
            return new CommonResponse(false, 5555, err)
        }
    }

    async getUnitsForCodeList(): Promise<CommonResponse> {
        const manager = getManager()
        const query = `SELECT uc.unit_name as unitName , uc.unit_code_id as unitId FROM ` + appSettings.masters_db + `.unitcodes uc WHERE uc.plant_type = 'PLANT' AND uc.is_active = 1 `
        const data = await manager.query(query)
        if (data.length > 0) {
            return new CommonResponse(true, 9999, 'data retrived successfully', data)
        } else {
            return new CommonResponse(false, 9999, 'No data Found')
        }
    }

}
